import "./Navbar.css"
import { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
export default function Navbar() {
  const navigate = useNavigate();
  const [showDropdown, setShowDropdown] = useState(false);
  return (
    <div>
      {/* 🔴 TOP HEADER */}
      <div
        style={{
          background: "#660909",
          color: "white",
          padding: "10px 20px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
          }}
        >
          {/* Logo + College Name */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "15px",
            }}
          >
            <img
              src="/logo.jpeg"
              alt="DIET Logo"
              style={{
                width: "70px",
                height: "70px",
                objectFit: "contain",
                borderRadius: "50%",
                background: "white",
                padding: "4px",
              }}
            />

            <div>
              <h2
                style={{
                  margin: 0,
                  fontSize: "24px",
                }}
              >
                DISTRICT INSTITUTE OF EDUCATION AND TRAINING - WEST GODAVARI
              </h2>

              <h4
                style={{
                  margin: "5px 0 0 0",
                  fontWeight: "normal",
                }}
              >
                Dubacherla, Nallajerla Mandal, East Godavari Dist, A.P 534112
              </h4>
            </div>
          </div>

          {/* Stats */}
          <div
            style={{
              display: "flex",
              gap: "20px",
              fontSize: "14px",
              marginTop: "10px",
            }}
          >
            <div>🎓 30+ Years Excellence</div>
            <div>🏆 NCTE Approved</div>
            <div>📚 D.El.Ed</div>
          </div>
        </div>
      </div>

      {/* ⚪ NAVIGATION BAR */}
      <div
        style={{
          background: "white",
          padding: "12px 20px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderBottom: "1px solid #ddd",
          flexWrap: "wrap",
        }}
      >
        {/* Links */}
        <div
          style={{
            display: "flex",
            gap: "20px",
            flexWrap: "wrap",
          }}
        >
          <NavLink
  to="/"
  style={({ isActive }) =>
    isActive ? activeLinkStyle : linkStyle
  }
>
  HOME
</NavLink>

<NavLink
  to="/about"
  style={({ isActive }) =>
    isActive ? activeLinkStyle : linkStyle
  }
>
  ABOUT US
</NavLink>

<NavLink
  to="/gallery"
  style={({ isActive }) =>
    isActive ? activeLinkStyle : linkStyle
  }
>
  GALLERY
</NavLink>

<NavLink
  to="/faculty"
  style={({ isActive }) =>
    isActive ? activeLinkStyle : linkStyle
  }
>
  FACULTY
</NavLink>

<NavLink
  to="/downloads"
  style={({ isActive }) =>
    isActive ? activeLinkStyle : linkStyle
  }
>
  DOWNLOADS
</NavLink>

<NavLink
  to="/contact"
  style={({ isActive }) =>
    isActive ? activeLinkStyle : linkStyle
  }
>
  CONTACT
</NavLink>
        </div>

      
    <div className="dropdown">
      <button
        className="dropbtn"
        onClick={() => setShowDropdown(!showDropdown)}
      >
        Login ▼
      </button>

      {showDropdown && (
        <div className="dropdown-content" style={{
    position: "absolute",
    top: "100%",
    left: 0,
    background: "white",
    minWidth: "180px",
    zIndex: 9999,
    boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
  }}>
          <div onClick={() => navigate("/student-login")}>
            Student Login
          </div>

          <div onClick={() => navigate("/faculty-login")}>
            Faculty Login
          </div>

          <div onClick={() => navigate("/admin-login")}>
            Admin Login
          </div>
        </div>
      )}
    </div>

      </div>
    </div>
  );
}
const linkStyle = {
  textDecoration: "none",
  color: "#333",
  fontWeight: "bold",
  padding: "10px 0",
  transition: "0.3s",
};

const activeLinkStyle = {
  textDecoration: "none",
  color: "#b30000",
  fontWeight: "bold",
  padding: "10px 0",
  borderBottom: "3px solid #b30000",
  transition: "0.3s",
};
